'use strict';

angular.module('mobile-apps').controller('AddToTmController', [
	'$scope',
	'$modalInstance',
	function (
		$scope,
		$modalInstance
	) {

		$scope.options = [
			{
				id: 'languages',
				choices: [
					{
						key: 'all',
						text: 'Add in all languages'
					},
					{
						key: 'current',
						text: 'Add only in current language'
					}
				],
				selected: 'all'
			},
			{
				id: 'publish',
				choices: [
					{
						key: 'publishAndOverwrite',
						text: 'Publish and overwrite'
					},
					{
						key: 'publishNewDraftExisting',
						text: 'Publish new & add Drafts for existing'
					},
					{
						key: 'onlyAsDraft',
						text: 'Add only as Drafts'
					}
				],
				selected: 'publishAndOverwrite'
			}
		];


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Starts Add To TM process
		 */
		$scope.startAddToTm = function () {

			var returnOptions = {};
			$scope.options.forEach(function(option) {
				returnOptions[option.id] = option.selected;
			});

			$modalInstance.close(returnOptions);
		};

	}
]);

